import type { FaireProductEntity } from "../../entity_types/product";

export const p_xfv6fgb39w: FaireProductEntity = {
  token: "p_xfv6fgb39w",
  type: "product",
  name: "Minimalist 18K Golden Stainless Steel Lariat Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl: "https://cdn.faire.com/fastly/30519eb85fb331da29c575c54f8da469c5dd8a629ee3a663351b20ca7d146d8b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/59fc3039118a44b83401986679c7295791e0baed069a54a96961709ebd0e9e27.jpeg",
    "https://cdn.faire.com/fastly/88d673fa022dd5acc24a42f29ddc8093ee1d8e82b1fa284616519b63116f3260.jpeg"
  ],
  priceDollars: 6.89,
  description: "\nType: Lariat & Y-neck necklace\n\nMaterial: 316L Stainless steel ，18K gold plated\n\n\nLength chain ： 700mm\n\nProcess: Vacuum electroplating and manual polishing,Non tarnish\n\nSurface : High Polish\n\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n\n★Perfect jewelry gifts \n",
  tags: [],
  msrpDollars: 18.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:59.522Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
